import React from "react";
import styled from "styled-components";

const DEFAULT_PROFILE = 'https://picture.link-zone.org/ZoneLogo.png';

// 이미지 로드 실패 시 디폴트 이미지로 대체
const handleImageError = (e) => {
  e.target.src = DEFAULT_PROFILE;
};

// 코치 프로필 이미지 렌더링 //
function CoachProfileImages({ teacherProfile, teacherProfiles, backgroundColor }) {
  // 단일 프로필인 경우
  if (!teacherProfiles || teacherProfiles.length <= 1) {
    return (
      <CoachImageBackground backgroundColor={backgroundColor} isTwoPhotos={false}>
        <CoachImage
          src={teacherProfile || DEFAULT_PROFILE}
          alt="coach profile"
          onError={handleImageError}
        />
      </CoachImageBackground>
    );
  }

  // 여러 프로필인 경우 (2명 이상)
  const profileCount = teacherProfiles.length;

  return (
    <CoachImageBackground backgroundColor={backgroundColor} isTwoPhotos={profileCount === 2}>
      <CoachImageGrid>
        {/* 왼쪽 위 (0,0) - 항상 표시 */}
        <TopLeftItem>
          <CoachImageSmall src={teacherProfiles[0] || DEFAULT_PROFILE} alt="coach 1" onError={handleImageError} />
        </TopLeftItem>

        {/* 오른쪽 위 (0,1) - 3명 이상일 때 */}
        {profileCount >= 3 && (
          <TopRightItem>
            <CoachImageSmall src={teacherProfiles[1] || DEFAULT_PROFILE} alt="coach 2" onError={handleImageError} />
          </TopRightItem>
        )}

        {/* 왼쪽 아래 (1,0) - 3명 이상일 때 */}
        {profileCount >= 3 && (
          <BottomLeftItem>
            <CoachImageSmall src={teacherProfiles[2] || DEFAULT_PROFILE} alt="coach 3" onError={handleImageError} />
          </BottomLeftItem>
        )}

        {/* 오른쪽 아래 (1,1) - 2명일 때 또는 4명 이상일 때 */}
        {(profileCount === 2 || profileCount >= 4) && (
          <BottomRightItem>
            <CoachImageSmall
              src={teacherProfiles[profileCount === 2 ? 1 : 3] || DEFAULT_PROFILE}
              alt="coach 4"
              onError={handleImageError}
            />
          </BottomRightItem>
        )}
      </CoachImageGrid>
    </CoachImageBackground>
  );
}

export default React.memo(CoachProfileImages);

const CoachImageBackground = styled.div`
  width: 31px;
  height: 31px;

  border-radius: ${props => props.isTwoPhotos ? '0 0 0 5px' : '0 0 0 10px'};

  background-color: ${props => props.backgroundColor};
`;

const CoachImage = styled.img`
  width: 31px;
  height: 31px;

  border-radius: 0 0 0 5px;

  object-fit: cover;

  background-color: rgba(255, 255, 255, 0.2);
`;

const CoachImageGrid = styled.div`
  display: grid;
  grid-template-columns: 15.5px 15.5px;
  grid-template-rows: 15.5px 15.5px;
  width: 31px;
  height: 31px;
  position: relative;

  background-color: rgba(255, 255, 255, 0.2);
`;

const CoachImageGridItemBase = styled.div`
  width: 15.5px;
  height: 15.5px;
  overflow: hidden;
`;

const TopLeftItem = styled(CoachImageGridItemBase)`
  grid-column: 1;
  grid-row: 1;
`;

const TopRightItem = styled(CoachImageGridItemBase)`
  grid-column: 2;
  grid-row: 1;
`;

const BottomLeftItem = styled(CoachImageGridItemBase)`
  grid-column: 1;
  grid-row: 2;
  border-radius: 0 0 0 5px;
`;

const BottomRightItem = styled(CoachImageGridItemBase)`
  grid-column: 2;
  grid-row: 2;
`;

const CoachImageSmall = styled.img`
  width: 15.5px;
  height: 15.5px;
  object-fit: cover;
`;
